<mat-toolbar class="topbar">
  <app-branding></app-branding>

   @if(!showToggle) {
    <button
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="d-flex justify-content-center"
    >
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    }@else {
      <span class="flex-1-auto"></span>
      <div class="d-flex align-items-center justify-content-center">
        @for(items of navItems; let i = $index; track items) {
          <button mat-button [routerLink]="items.route" color="primary" class="m-r-10">
            <mat-icon>{{items.matIconName}}</mat-icon>
            {{items.displayName}}
          </button>
          @if (i < navItems.length - 1) {
            <div class="vertical-divider"></div>
          }
        }
      </div>
    }

  <!-- --------------------------------------------------------------- -->



  <span class="flex-1-auto"></span>
  <!-- <span class="flex-1-auto"></span> -->


  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
<button
  mat-icon-button
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="notificationmenu"
  aria-label="Notifications"
  class="m-r-32"
>
  <mat-icon
    [matBadge]="numeroNotifiche?.size ?? 0"
    matBadgeOverlap="false"
    matBadgeColor="warn"
    class="header-badge"
  >
    notifications
  </mat-icon>
</button>

<mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow" >
  <div class="d-flex align-items-center p-x-32 p-y-16">
    <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">Notifiche</h6>
    <span class="m-l-auto">
      <button
        mat-icon-button
        class="close-btn"
        (click)="menuTrigger.closeMenu()"
        aria-label="Close notifications"
      >
        <mat-icon>close</mat-icon>
      </button>
    </span>
  </div>



  @for (notification of notificheUtente; track notification) {
    <button mat-menu-item class="p-x-32 p-y-16" (click)="goDetailNotifica(notification.id!)">
      <div class="d-flex align-items-center">
        <img src="./assets/images/backgrounds/notification.webp" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <span>{{ notification.createdAt }}</span>
          <h5 class="f-s-12 f-w-600 m-0 mat-subtitle-1" style="word-break: break-all;">
            {{ notification.subject }}
          </h5>
        </div>
      </div>
    </button>
  }

  <div class="p-y-12 p-x-32">
    <button mat-stroked-button color="primary" class="w-100" [routerLink]="['/lista-notifiche']">
      Vedi Tutte le Notifiche
    </button>
  </div>
</mat-menu>

  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Notifications"
  >
    <img
      src="./assets/images/profile/profile.png"
      class="rounded-circle object-cover icon-35 profile-dd"
      width="35"
    />
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow" >
    <ng-scrollbar class="position-relative" style="height: 60vh" *ngIf="userLoaded">
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">{{user?.username}}</h6>

        <div class="d-flex p-b-24 b-b-1 m-t-16" style="flex-direction: column;">
          <div class="d-flex justify-content-center align-items-center m-b-4">
          <img
            src="./assets/images/profile/profile.png"
            class="rounded-circle"
            width="95"
          />
          </div>
          <div>
            <!-- <h6 class="f-s-14 f-w-600 m-0 mat-subtitle-1">{{user?.username}}</h6> -->
            <span class="d-flex align-items-center m-b-4">
              <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
              {{user?.email}}
            </span>
            <diV class="d-flex justify-content-between align-items-start">
              <span class="f-s-14 f-w-600 d-block m-b-4">Ruoli:</span>
              <div class="d-flex" style="flex-direction: column;">
                @for(role of user?.authorization.roles; track role) {
                <span class="f-s-14 d-block m-b-4 text-end">
                  {{role}}
                </span>
                 }
              </div>
            </diV>
           
            <!-- <diV class="d-flex justify-content-between align-items-start">
              <span class="f-s-14 f-w-600 d-block m-b-4">Gestore:</span><span class="f-s-14 d-block m-b-4 text-end" style="width: 14rem;"> {{waterSupplyCommpanySelected().companyName}}</span>
            </diV>
            <diV class="d-flex justify-content-between align-items-start">
            <span class="f-s-14 f-w-600 d-block m-b-4">Cod. Arera:</span><span class="f-s-14 d-block m-b-4 text-end"> {{waterSupplyCommpanySelected().idArera}}</span>
            </diV> -->
          </div>
        </div>
      </div>
    <!--  <div class="p-x-32">
        @for(profile of profiledd; track profile.title) {
        <a
          class="p-y-16 text-decoration-none d-block text-hover-primary"
          [routerLink]="[profile.link]"
        >
          <div class="d-flex align-items-center">
            <button
              mat-mini-fab
              class="text-primary bg-light-primary shadow-none rounded"
            >
              <img [src]="profile.img" width="20" />
            </button>

            <div class="m-l-16">
              <h5
                class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text"
              >
                {{ profile.title }}
              </h5>
              <span class="mat-body-1">{{ profile.subtitle }}</span>
            </div>
          </div>
        </a>
        }


      </div>-->

      <div class="p-y-12 p-x-32">
        <a
          (click)="logout()"
          mat-stroked-button
          color="primary"
          class="w-100"
          >Logout</a
        >
      </div>
    </ng-scrollbar>
  </mat-menu>
</mat-toolbar>
